(function (window) {
  function BatchGeoMunkres() {
    this.costMatrixX = null;
    this.rCover = [];
    this.cCover = [];
    this.n = 0;
    this.maskMatrix = null;
    this.path = null;
  }

  BatchGeoMunkres.prototype.padMatrix = function (matrix, _value) {
    let maxColumns = 0;

    //find max
    for (let x = 0; x < matrix.length; x++) {
      if (matrix[x].length > maxColumns) maxColumns = matrix[x].length;
    }

    let tRows = maxColumns > matrix.length ? maxColumns : matrix.length;

    let newMatrix = [];

    for (let x = 0; x < matrix.length; x++) {
      let row = matrix[x] || [];
      var nRow = row.slice();

      //pad row
      while (tRows > nRow.length) nRow.push(0);

      newMatrix.push(nRow);
    }

    return newMatrix;
  };

  BatchGeoMunkres.prototype.makeMatrix = function (n, val) {
    var munkmatrix = [];
    for (var i = 0; i < n; ++i) {
      munkmatrix[i] = [];
      for (var j = 0; j < n; ++j) munkmatrix[i][j] = val;
    }
    return munkmatrix;
  };

  BatchGeoMunkres.prototype.makeVector = function (n, val) {
    var vector = [];
    for (var i = 0; i < n; ++i) {
      vector.push(val);
    }
    return vector;
  };

  //reduce rows by the lowest value of each row
  BatchGeoMunkres.prototype.step1 = function () {
    for (let rowIndex = 0; rowIndex < this.n; ++rowIndex) {
      let minValueInRow = Math.min.apply(null, this.costMatrixX[rowIndex]);

      for (let colIndex = 0; colIndex < this.n; ++colIndex) {
        this.costMatrixX[rowIndex][colIndex] -= minValueInRow;
      }
    }
    return 2;
  };

  //star a zero?
  BatchGeoMunkres.prototype.step2 = function () {
    for (let rowIndex = 0; rowIndex < this.n; ++rowIndex) {
      for (let colIndex = 0; colIndex < this.n; ++colIndex) {
        if (
          this.costMatrixX[rowIndex][colIndex] == 0 &&
          this.rCover[rowIndex] == 0 &&
          this.cCover[colIndex] == 0
        ) {
          this.maskMatrix[rowIndex][colIndex] = 1;
          this.rCover[rowIndex] = 1;
          this.cCover[colIndex] = 1;
        }
      }
    }

    //clear covers
    for (let rowIndex = 0; rowIndex < this.n; ++rowIndex) {
      this.rCover[rowIndex] = 0;
      this.cCover[rowIndex] = 0;
    }

    return 3;
  };

  //cover column
  BatchGeoMunkres.prototype.step3 = function () {
    for (let rowIndex = 0; rowIndex < this.n; ++rowIndex) {
      for (let colIndex = 0; colIndex < this.n; ++colIndex) {
        if (
          this.maskMatrix[rowIndex][colIndex] == 1 &&
          this.cCover[colIndex] == 0
        ) {
          this.cCover[colIndex] = 1;
        }
      }
    }

    let count = 0;

    for (let colIndex = 0; colIndex < this.n; ++colIndex) {
      count += this.cCover[colIndex];
    }

    if (count >= this.n) {
      return 7; // step
    } else {
      return 4; // step
    }
  };

  //reduce cols by the lowest amount
  BatchGeoMunkres.prototype.step4 = function () {
    let row = -1;
    let col = -1;
    let done = false;
    let step;

    while (!done) {
      let z = this.findAZero();
      row = z[0];
      col = z[1];

      if (row < 0) {
        done = true;
        step = 6;
      } else {
        this.maskMatrix[row][col] = 2;
        if (this.findStarInRow(row) >= 0) {
          col = this.findStarInRow(row);
          this.rCover[row] = 1;
          this.cCover[col] = 0;
        } else {
          this.Z0_r = row;
          this.Z0_c = col;
          done = true;
          step = 5;
        }
      }
    }
    return step;
  };

  BatchGeoMunkres.prototype.step5 = function () {
    let count = 0;

    this.path[count][0] = this.Z0_r;
    this.path[count][1] = this.Z0_c;

    let done = false;

    while (!done) {
      let row = this.findStarInCol(this.path[count][1]);
      if (row >= 0) {
        count++;
        this.path[count][0] = row;
        this.path[count][1] = this.path[count - 1][1];
      } else {
        done = true;
      }
      if (!done) {
        let col = this.findPrimeInRow(this.path[count][0]);
        count++;
        this.path[count][0] = this.path[count - 1][0];
        this.path[count][1] = col;
      }
    }
    this.convertPath(this.path, count);
    for (let rowIndex = 0; rowIndex < this.n; ++rowIndex) {
      this.rCover[rowIndex] = 0;
      this.cCover[rowIndex] = 0;
    }
    this.removePrimes();
    return 3; //step
  };

  BatchGeoMunkres.prototype.step6 = function () {
    var minval = this.findSmallest();

    for (var i = 0; i < this.n; ++i) {
      for (var j = 0; j < this.n; ++j) {
        if (this.rCover[i]) this.costMatrixX[i][j] += minval;
        if (!this.cCover[j]) this.costMatrixX[i][j] -= minval;
      }
    }

    return 4;
  };

  BatchGeoMunkres.prototype.findSmallest = function () {
    var minval = 1000000; //keep it reasonable

    for (var i = 0; i < this.n; ++i)
      for (var j = 0; j < this.n; ++j)
        if (!this.rCover[i] && !this.cCover[j])
          if (minval > this.costMatrixX[i][j]) minval = this.costMatrixX[i][j];

    return minval;
  };

  BatchGeoMunkres.prototype.findAZero = function () {
    for (var i = 0; i < this.n; ++i) {
      for (var j = 0; j < this.n; ++j) {
        if (this.costMatrixX[i][j] === 0 && !this.rCover[i] && !this.cCover[j])
          return [i, j];
      }
    }

    return [-1, -1];
  };

  BatchGeoMunkres.prototype.findStarInRow = function (row) {
    // col = 0;
    for (let j = 0; j < this.n; j++) {
      if (this.maskMatrix[row][j] == 1) {
        return j;
      }
    }
    return -1;
  };

  BatchGeoMunkres.prototype.removePrimes = function () {
    for (var i = 0; i < this.n; ++i)
      for (var j = 0; j < this.n; ++j)
        if (this.maskMatrix[i][j] == 2) this.maskMatrix[i][j] = 0;
  };

  BatchGeoMunkres.prototype.findPrimeInRow = function (row) {
    for (var j = 0; j < this.n; ++j) if (this.maskMatrix[row][j] == 2) return j;

    return -1;
  };

  BatchGeoMunkres.prototype.findStarInCol = function (col) {
    for (var i = 0; i < this.n; ++i) if (this.maskMatrix[i][col] == 1) return i;

    return -1;
  };

  BatchGeoMunkres.prototype.convertPath = function (path, count) {
    for (var i = 0; i <= count; ++i)
      this.maskMatrix[path[i][0]][path[i][1]] =
        this.maskMatrix[path[i][0]][path[i][1]] == 1 ? 0 : 1;
  };

  BatchGeoMunkres.prototype.run = function (costMatrix) {
    var cost = this.padMatrix(costMatrix.slice(), 0);

    var step = 1;

    var steps = {
      1: this.step1,
      2: this.step2,
      3: this.step3,
      4: this.step4,
      5: this.step5,
      6: this.step6,
    };

    this.createMatricies(cost);

    //run the algorithm steps
    // TODO(tom) code clarity can be improved here
    // eslint-disable-next-line no-constant-condition
    while (true) {
      var func = steps[step];

      if (!func)
        // done
        break;

      step = func.apply(this);
    }

    var results = [];
    for (var i = 0; i < this.n; ++i)
      for (var j = 0; j < this.n; ++j)
        if (this.maskMatrix[i][j] == 1) {
          results.push([i, j]);
        }

    return results;
  };

  BatchGeoMunkres.prototype.createMatricies = function (costMatrix) {
    this.costMatrixX = costMatrix.slice();
    this.n = this.costMatrixX.length;
    this.maskMatrix = this.makeMatrix(this.n, 0);
    this.rCover = this.makeVector(this.n, 0);
    this.cCover = this.makeVector(this.n, 0);
    this.path = this.makeMatrix(this.n * 2, 0);
  };
  window.BatchGeoMunkres = BatchGeoMunkres;
})(window);
